import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useShallowEqualSelector, useTranslate } from '@hooks';
import { createNetworkAffiliatePreference } from '@actions';
import { Input, Form, FormAction, Button, ButtonCancel } from '@dotone/react-ui-core';
import { FormGroup } from 'reactstrap';

const AffiliateInternalNotesForm = ({ defaultValues, onCancel, ...otherProps }) => {
  const { t } = useTranslate('common', 'actions');
  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    dispatch(createNetworkAffiliatePreference(defaultValues.affiliateId, values));
  };

  const { status, isLoading } = useShallowEqualSelector(
    ({ networkAffiliatePreferenceCreate }) => networkAffiliatePreferenceCreate
  );

  useEffect(() => {
    if (!isLoading && status === 'success') {
      onCancel();
    }
  }, [onCancel, isLoading, status]);

  return (
    <Form onSubmit={handleSubmit} defaultValues={defaultValues} {...otherProps}>
      <FormGroup>
        <Input type="textarea" name="internalNotes" rows={6} rules={{ maxLength: 500 }} />
      </FormGroup>
      <FormAction align="right">
        <Button variant="save" color="primary" submitting={isLoading}>
          {t('save')}
        </Button>
        {onCancel && <ButtonCancel disabled={isLoading} onClick={onCancel} />}
      </FormAction>
    </Form>
  );
};

export default AffiliateInternalNotesForm;
